import React, { useState, useEffect } from "react";
import Header from "../../components/header/header";
import Pagination from "react-bootstrap/Pagination";
import { useNavigate, useParams } from "react-router-dom";
import Spinner from "react-bootstrap/Spinner";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import "./gerenciamentoPlanos.css";
import CustomModal from "../../components/modal/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckDouble,
  faFilter,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import { filterAplicacoesPlanos } from "../../services/api_aplicacoes_planos";
import Swal from "sweetalert2";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import { blue } from "@mui/material/colors";
import Paper from "@mui/material/Paper";

import FiltroAplicacoesPlano from "../../components/aplicacoesPlano/aplicacoesPlanoFilter";
import { postOrdem } from "../../services/api_cadastro_ordens_servico";
import { format } from "date-fns";
import { Permissions } from "../../hooks/Permission/permission";
import dataFormatada from "../../hooks/Date/dataFormatada";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: blue[600],
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const GerenciamentoPlanos = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const itemsPerPageOptions = [5, 10, 20, 50];
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [dados, setDados] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({});
  const [filters, setFilters] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const [isSelectAll, setIsSelectAll] = useState(false);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleOpenModal = (title, body, isQuestion, qFunc) => {
    setModalContent({ title, body, isQuestion, qFunc });
    setShowModal(true);
  };

  const handleApplyFilters = async (filters) => {
    try {
      setLoading(true);
      const response = await filterAplicacoesPlanos(filters);
      setFilters({
        id_tipo_aplicacao: filters.id_tipo_aplicacao,
        id_aplicacao: filters.id_aplicacao,
        id_plano: filters.id_plano,
        dataInicial: filters.dataInicial,
        dataFinal: filters.dataFinal,
      });
      console.log("dados aplicação plano", response);
      setDados(response.data.AplicacoesPlanosManutencao);
      setLoading(false);
    } catch (error) {
      console.error("Erro ao obter dados:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchAplicacoesPlanos = async () => {
      try {
        setLoading(true);
        const response = await filterAplicacoesPlanos();
        if (response) {
          setDados(response.data.AplicacoesPlanosManutencao);
        }
        setLoading(false);
      } catch (error) {
        console.error("Erro ao obter dados:", error);
        setLoading(false);
      }
    };
    fetchAplicacoesPlanos();
  }, []);

  useEffect(() => {
    const filterData = () => {
      if (dados && dados.length > 0) {
        const filtered = dados.filter(
          (item) =>
            item.id_plano.toString().includes(searchTerm.toString()) ||
            item.id_aplicacao.toString().includes(searchTerm.toString()) ||
            item.plano_manutencao?.descricao
              .toLowerCase()
              .includes(searchTerm.toLowerCase()) ||
            item.aplicacao?.descricao
              .toLowerCase()
              .includes(searchTerm.toLowerCase()) ||
            item.id.toString().includes(searchTerm.toString())
        );

        setFilteredData(filtered);
        setCurrentPage(1);
      } else {
        setFilteredData([]);
        setCurrentPage(1);
      }
    };

    filterData();
  }, [searchTerm, dados]);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = searchTerm
    ? filteredData
      ? filteredData.slice(indexOfFirstItem, indexOfLastItem)
      : []
    : dados && dados.length > 0
    ? dados.slice(indexOfFirstItem, indexOfLastItem)
    : [];

  const totalPages = Math.ceil(
    (searchTerm
      ? filteredData
        ? filteredData.length
        : 0
      : dados
      ? dados.length
      : 0) / itemsPerPage
  );

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(parseInt(event.target.value));
    setCurrentPage(1);
  };

  const renderPaginationItems = () => {
    const paginationItems = [];

    paginationItems.push(
      <Pagination.Prev
        key="prev"
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
      />
    );

    paginationItems.push(
      <Pagination.Item
        key={1}
        active={1 === currentPage}
        onClick={() => handlePageChange(1)}
      >
        {1}
      </Pagination.Item>
    );

    if (currentPage > 3) {
      paginationItems.push(
        <Pagination.Ellipsis key="ellipsis-start" disabled />
      );
    }

    for (
      let i = Math.max(2, currentPage - 2);
      i <= Math.min(totalPages - 1, currentPage + 2);
      i++
    ) {
      paginationItems.push(
        <Pagination.Item
          key={i}
          active={i === currentPage}
          onClick={() => handlePageChange(i)}
        >
          {i}
        </Pagination.Item>
      );
    }

    if (currentPage < totalPages - 2) {
      paginationItems.push(<Pagination.Ellipsis key="ellipsis-end" disabled />);
    }

    if (totalPages > 1) {
      paginationItems.push(
        <Pagination.Item
          key={totalPages}
          active={totalPages === currentPage}
          onClick={() => handlePageChange(totalPages)}
        >
          {totalPages}
        </Pagination.Item>
      );
    }

    paginationItems.push(
      <Pagination.Next
        key="next"
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      />
    );

    return paginationItems;
  };

  const generateDataRows = () => {
    if (currentItems.length === 0) {
      return (
        <TableRow>
          <StyledTableCell colSpan={8} align="center">
            Nenhum resultado encontrado
          </StyledTableCell>
        </TableRow>
      );
    }

    return currentItems.map((item) => (
      <TableRow key={item.id}>
        <Permissions
          requiredPermissions={[
            {
              entidade: "AplicacaoPlanoManutencao",
              actions: ["store"],
            },
          ]}
        >
          <StyledTableCell>
            <Form.Check
              style={{
                position: "sticky",
                left: 0,
                background: "white",
                zIndex: 1,
              }}
              type="checkbox"
              className="ml-5 mb-3 custom-checkbox"
              checked={selectedRows.includes(item.id)}
              onChange={() => handleRowSelect(item)}
            />
          </StyledTableCell>
        </Permissions>
        <StyledTableCell>{item.id}</StyledTableCell>
        <StyledTableCell>{`${item.id_aplicacao || "Aplicação Indisponível"} - ${
          item.aplicacao?.descricao || "Aplicação Indisponível"
        }`}</StyledTableCell>
        <StyledTableCell>
          {`${
            item.aplicacao?.tipo_aplicacao?.id ||
            "Tipo de Aplicação Indisponível"
          } - ${
            item.aplicacao?.tipo_aplicacao?.descricao ||
            "Tipo de Aplicação Indisponível"
          }`}
        </StyledTableCell>
        <StyledTableCell>{`${
          item.id_plano || "Plano de Manutenção Indisponível"
        } - ${
          item.plano_manutencao?.descricao || "Plano de Manutenção Indisponível"
        }`}</StyledTableCell>
        <StyledTableCell>{item.periodicidade}</StyledTableCell>
        <StyledTableCell>
          {item.ultima_manutencao
            ? dataFormatada(item.ultima_manutencao)
            : "Indefinida"}
        </StyledTableCell>
        <StyledTableCell>
          {item.proxima_manutencao
            ? dataFormatada(item.proxima_manutencao)
            : "Indefinida"}
        </StyledTableCell>
      </TableRow>
    ));
  };

  const handleRowSelect = (item) => {
    const isSelected = selectedRows.includes(item.id);
    const updatedSelectedRows = isSelected
      ? selectedRows.filter((rowId) => rowId !== item.id)
      : [...selectedRows, item.id];
    const updatedSelectedData = isSelected
      ? selectedData.filter((data) => data.id !== item.id)
      : [...selectedData, item];

    setSelectedRows(updatedSelectedRows);
    setSelectedData(updatedSelectedData);
  };

  const handleSelectAll = () => {
    if (isSelectAll) {
      setSelectedRows([]);
      setSelectedData([]);
    } else {
      const allRows = currentItems.map((item) => item.id);
      setSelectedRows(allRows);
      setSelectedData(currentItems);
    }
    setIsSelectAll(!isSelectAll);
  };

  const handleSendSelectedData = async () => {
    if (selectedData.length > 0) {
      try {
        Swal.fire({
          title: "Aguarde...",
          text:
            selectedData.length > 1
              ? "Gerando ordens de serviço..."
              : "Gerando ordem de serviço...",
          allowOutsideClick: false,
          didOpen: async () => {
            Swal.showLoading();

            // Mapeia os dados selecionados para criar o array de objetos
            const requestData = selectedData.map((item) => {
              const previsaoInicio = new Date(item.proxima_manutencao);
              const previsaoTermino = new Date(previsaoInicio);
              previsaoTermino.setDate(previsaoTermino.getDate() + 1);

              return {
                solicitacao: `Executar o plano "${item.plano_manutencao?.descricao}"`,
                previsao_inicio: format(previsaoInicio, "yyyy-MM-dd HH:mm:ss"), // Formata a data para 'YYYY-MM-DD H:i:s'
                previsao_termino: format(
                  previsaoTermino,
                  "yyyy-MM-dd HH:mm:ss"
                ), // Formata a data para 'YYYY-MM-DD H:i:s'
                id_aplicacao: item.id_aplicacao,
                nome_aplicacao: item.aplicacao.descricao,
                descricao_plano: item.plano_manutencao.descricao,
                id_unidade: item.aplicacao.id_unidade,
                id_tipo_manutencao: item.plano_manutencao.id_tipo_manutencao,
                id_plano_manutencao: item.id_plano,
                id_user_gerou: localStorage.getItem("userId"),
                situacao: 0,
              };
            });

            try {
              const response = await postOrdem(requestData);

              if (response && response.status === 200) {
                Swal.fire({
                  icon: "success",
                  title: "Sucesso!",
                  text:
                    selectedData.length > 1
                      ? "Ordens de serviço cadastradas com sucesso."
                      : "Ordem de serviço cadastrada com sucesso",
                });
              }
            } catch (error) {
              console.error("Erro ao enviar dados:", error);

              const errorMessages = error.map((err) => err.errors).join("\n\n"); // Mantém as quebras de linha no texto
              Swal.fire({
                icon: "error",
                title: "Erro",
                html: `<pre>${errorMessages}</pre>`, // Usa <pre> para manter o formato do texto
              });
            }
          },
        });
      } catch (error) {
        console.error("Erro ao exibir mensagem:", error);
      }
    } else {
      Swal.fire({
        icon: "warning",
        title: "Nenhum registro selecionado",
        text: "Selecione pelo menos um registro para criar uma ordem de serviço.",
      });
    }
  };

  return (
    <>
      <Header title="Serviços / Gerenciamento de planos" />
      <div className="content-wrapper pl-5 pr-5 pt-2">
        <Container fluid>
          <Permissions
            requiredPermissions={[
              {
                entidade: "AplicacaoPlanoManutencao",
                actions: ["store"],
              },
            ]}
          >
            <Row className="mb-3">
              <FiltroAplicacoesPlano onApplyFilters={handleApplyFilters} />
            </Row>
          </Permissions>
          <Row>
            <Col md={1} className="mb-3">
              <Form.Group className="d-flex align-items-center">
                <FontAwesomeIcon
                  icon={faFilter}
                  size="1x"
                  color="#000000"
                  className="mr-2"
                />

                <Form.Control
                  as="select"
                  value={itemsPerPage}
                  onChange={handleItemsPerPageChange}
                  className="ml-2"
                >
                  {itemsPerPageOptions.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>
            <Col md={3} className="mb-3 ml-auto">
              <Form.Group className="d-flex align-items-center">
                <FontAwesomeIcon
                  icon={faSearch}
                  size="1x"
                  color="#000000"
                  className="mr-2"
                />

                <Form.Control
                  type="text"
                  placeholder="Digite para pesquisar"
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="ml-2"
                />
              </Form.Group>
            </Col>
          </Row>

          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <Permissions
                    requiredPermissions={[
                      {
                        entidade: "AplicacaoPlanoManutencao",
                        actions: ["store"],
                      },
                    ]}
                  >
                    <StyledTableCell align="center">
                      <Button onClick={() => handleSelectAll()}>
                        <FontAwesomeIcon icon={faCheckDouble} />
                      </Button>
                    </StyledTableCell>
                  </Permissions>
                  <StyledTableCell>ID</StyledTableCell>
                  <StyledTableCell>Aplicação</StyledTableCell>
                  <StyledTableCell>Tipo</StyledTableCell>
                  <StyledTableCell>Plano</StyledTableCell>
                  <StyledTableCell>Periodicidade (dias)</StyledTableCell>
                  <StyledTableCell>Última Manutenção</StyledTableCell>
                  <StyledTableCell>Próxima Manutenção</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoading ? (
                  <TableRow>
                    <StyledTableCell colSpan={8} align="center">
                      <Spinner animation="border" />
                    </StyledTableCell>
                  </TableRow>
                ) : (
                  generateDataRows()
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <Row className="mt-3">
            <Col>
              <Pagination>{renderPaginationItems()}</Pagination>
            </Col>
          </Row>
          <Row className="mt-3">
            <Permissions
              requiredPermissions={[
                { entidade: "OrdensServico", actions: ["store"] },
              ]}
            >
              <Col>
                <Button variant="primary" onClick={handleSendSelectedData}>
                  Gerar Ordens de Serviço
                </Button>
              </Col>
            </Permissions>
          </Row>
        </Container>
      </div>

      <CustomModal
        showModal={showModal}
        handleCloseModal={handleCloseModal}
        title={modalContent.title}
        body={modalContent.body}
        isQuestion={modalContent.isQuestion}
        qFunc={modalContent.qFunc}
      />
    </>
  );
};

export default GerenciamentoPlanos;
